.container {
	box-sizing: border-box;
	display: flex;
	padding: 10px;
	border-radius: 5px;
	position: absolute;
	border: 1px solid var(--ds-border, var(--adg3-color-N50));
	flex-direction: column;
	background-color: var(--ds-background-neutral, var(--adg3-color-N10));
	z-index: -1;
}

.name {
	position: absolute;
	display: flex;
	align-items: center;
	padding: 10px;
	box-sizing: border-box;
}

.title {
	margin-left: 5px;
	font-weight: 600;
	min-width: 0;
}
